import { Stack, Typography, Tooltip, Box, Divider } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SyncIcon from '@mui/icons-material/Sync';
import { useTheme } from '@mui/material/styles';

export default function OfflineCard() {
  const theme = useTheme();

  return (
    <Stack
      spacing={3}
      alignItems="center"
      justifyContent="center"
      sx={{
        padding: '3em 2em',
        marginTop: '2em',
        maxWidth: '600px',
        margin: '2em auto 0'
      }}>
      {/* Main Icon */}
      <Tooltip
        enterTouchDelay={0}
        title="You are currently offline. Data will sync when connection is restored."
        arrow
        placement="top">
        <Box
          sx={{
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%': { opacity: 1 },
              '50%': { opacity: 0.3 },
              '100%': { opacity: 1 }
            }
          }}>
          <WifiOffIcon
            sx={{
              fontSize: 48,
              color: theme.palette.text.secondary,
              opacity: 0.7
            }}
          />
        </Box>
      </Tooltip>

      {/* Main Message */}
      <Stack spacing={1} alignItems="center" textAlign="center">
        <Typography
          variant="h6"
          fontWeight="500"
          sx={{
            color: theme.palette.text.primary,
            fontSize: '1.1rem'
          }}>
          Offline
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: '0.9rem',
            maxWidth: '400px'
          }}>
          Some features require internet connection, but you can still work with existing data.
        </Typography>
      </Stack>

      <Divider sx={{ width: '100%', opacity: 0.3 }} />

      {/* Available Features */}
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 600,
            textAlign: 'center'
          }}>
          Available Offline:
        </Typography>

        <Stack spacing={1.5}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <CheckCircleOutlineIcon sx={{ fontSize: 20, color: theme.palette.success.main }} />
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
              View and edit manifest data
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={2}>
            <CheckCircleOutlineIcon sx={{ fontSize: 20, color: theme.palette.success.main }} />
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
              Update quantities and package status
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={2}>
            <SyncIcon sx={{ fontSize: 20, color: theme.palette.info.main }} />
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
              Submit manifests (queued for sync)
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.secondary,
          fontSize: '0.8rem',
          textAlign: 'center',
          fontStyle: 'italic',
          opacity: 0.8
        }}>
        Changes will automatically sync when you reconnect
      </Typography>
    </Stack>
  );
}
